<div [hidden]="!visible">
  <div class="spinner-overlay"></div>
  <div class="spinner-container">
    <div class="spinner">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
</div>
